<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon> mdi-delete</v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to cancel this task ? </v-card-text>
      <v-textarea
        v-model="remark"
        v-validate="'required|max:255'"
        label="Remark"
        :rows="2"
        auto-grow
        outlined
        class="mx-2"
        data-vv-name="remark"
        :error-messages="errors.collect('remark')"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="close"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="cancel"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      task: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        remark: null,
      }
    },
    methods: {
      prepareFormData () {
        return {
          remark: this.remark,
        }
      },

      cancel () {
        this.$validator.validate('remark', this.remark)
          .then(result => {
            if (!result) return

            this.$api.ownerTasks().cancel(this.task.id, this.prepareFormData())
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.message })

                this.menu = false
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to delete task', 
                }) 
              })
              .then(() => {
                this.progressing = false
              })
          })
      },

      close () {
        this.$validator.reset()
        this.remark = null
        this.menu = false
      },
      
    },
  }
</script>
